@if (service.notification(); as notification) {
  <div class="approval-notification__overlay">
    <div class="approval-notification__card">

      <div
        class="approval-notification__icon-container"
        [class.approval-notification__icon-container--approved]="notification.type === 'approved'"
        [class.approval-notification__icon-container--rejected]="notification.type === 'rejected'"
        aria-hidden="true"
      >
        <div
          class="approval-notification__icon-circle"
          [class.approval-notification__icon-circle--approved]="notification.type === 'approved'"
          [class.approval-notification__icon-circle--rejected]="notification.type === 'rejected'"
        >
          <mat-icon class="approval-notification__icon-symbol">
            {{ notification.type === 'approved' ? 'check' : 'close' }}
          </mat-icon>
        </div>
      </div>

      <p class="approval-notification__title">{{ notification.title }}</p>

      <button class="approval-notification__btn" (click)="dismiss()">
        Зрозуміло
      </button>
    </div>
  </div>
}
